import setActivePanelSections from './guards/set-active-panel-sections';
import setDefaultMembershipLevel from './guards/set-default-membership-level';
import setDefaultPromo from './guards/set-default-promo';
import checkConfirmationData from './guards/check-confirmation-data';
import { Routes } from '@angular/router';
import { JoinFormComponent } from './components/join-form/join-form';
import { JoinConfirmationComponent } from './components/join-confirmation/join-confirmation';

export const routes: Routes = [
  {
    path: '',
    component: JoinFormComponent,
    canActivate: [setDefaultMembershipLevel, setDefaultPromo, setActivePanelSections],
  },
  {
    path: 'confirmation',
    component: JoinConfirmationComponent,
    canActivate: [checkConfirmationData],
  },
];
